module.exports = __webpack_public_path__ + "static/media/tutoring-flute.36de7b7f.png";